import { observable, action } from 'mobx';
import { isDataExist } from 'Utils/dataTools';
import * as services from '../services/ReportForms';
import { message } from 'antd';
import { omit } from 'lodash';

class ReportForms {
  @observable isLoading = false;
  @observable tableData = [];  //表格数据
  @observable PageInfo = { pageIndex: 1, pageSize: 10, total:0 }; //表格分页
  @observable searchData = [];

  //获取表格数据
  @action.bound async getData(params) {
    this.isLoading = true
    try {
      let res = await services.getRequest(services.requestUrl.getData, {
        ...omit(this.PageInfo, 'total'),
        ...params
      })
      this.isLoading = false
      if (isDataExist(res)) {
        this.tableData = res.data.data
        this.PageInfo.total = res.data.data.length
      }
    } catch (error) {
      console.log(error)
    }
  }

  //新增
  @action.bound async saveData(params) {
    this.isLoading = true
    try {
      let res = await services.putRequest(services.requestUrl.codeSave, params)
      this.isLoading = false
      if (isDataExist(res)) {
        return res
      }
    } catch (error) {
      console.log(error)
    }
    this.getData()
  }

  //打开/关闭模态框type=1为编辑，否则是新增
  @action.bound modalChange = (type, record) => {
    if (type) {
      this.formData = record;
    } else {
      this.formData = {};
    }
    this.modalVisible = !this.modalVisible;
  }

}
let ReportFormsStore = new ReportForms();
export default ReportFormsStore;
